// extracted by mini-css-extract-plugin
export default {"info_container":"Info_info_container__waAS6","parameters":"Info_parameters__NQdzc","parameter":"Info_parameter__+e1ON","description":"Info_description__z8hoR"};